import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useClientAuth } from "../contexts/ClientAuthContext";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setClient } = useClientAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1];
    if (!sessionId) {
      navigate("/portal-login");
      return;
    }
    api
      .post("/auth/client/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        setClient(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/portal", { state: { user: data } });
      })
      .catch(() => navigate("/portal-login"));
  }, [navigate, setClient]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
      <p className="font-heading uppercase tracking-[0.3em] text-sm text-[#A1A1AA]">Signing you in...</p>
    </div>
  );
}
